import React from 'react';
import Head from 'next/head';
import { getPageStaticProps } from 'lib/dato-request';
import SecondaryPageLayout from '@/components/ReusableUI/SecondaryPageLayout';
import FAQSection from '@/components/FAQ/FAQSection';
import BalanceText from '@/components/BalanceText/BalanceText';
import NormalText from '@/components/Views/Text';
import { generateFAQPageSchema } from '@/lib/schema';

const Faq = ({ data }) => {
    const { page } = data;
    const { components, seo } = page;
    const faqs = components[1].faqQuestion;
    const faqSchema = generateFAQPageSchema(faqs);

    return (
        <SecondaryPageLayout page={page} components={[components[2], components[3]]}>
            <Head>
                <script
                    type='application/ld+json'
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
                />
            </Head>
            <div className='faq-hero'>
                <h1>{components[0].heading}</h1>

                <NormalText as='div' className='mt-6 w-full text-left md:text-center'>
                    <span className='text-center w-full'>
                        <BalanceText>
                            {components[0].subhead}
                        </BalanceText>
                    </span>
                </NormalText>
            </div>
            <FAQSection faqs={components[1].faqQuestion} title={false} className='bg-[#f8f8f8]' background='#f8f8f8' />
            {/*<Accordion faqs={components[1].faqQuestion} />*/}
            <style jsx>{`
                .faq-hero {
                    background: #f9f9f9;
                    padding: 185px 40px 54px;

                    h1 {
                        font-weight: 800;
                        font-size: 48px;
                        line-height: 55px;
                        text-align: center;
                        background: -webkit-linear-gradient(135deg,
                        #e637a8 2.69%,
                        #e68137 75%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                        margin: 0;
                    }

                    p {
                        font-weight: 500;
                        font-size: 18px;
                        line-height: 33px;
                        text-align: center;
                        color: #4f4f4f;
                        margin: 23px 0 0;
                    }

                    @media (max-width: 768px) {
                        padding: 130px 28px 30px;

                        h1 {
                            font-size: 36px;
                        }

                        p {
                            font-size: 17px;
                            line-height: 28px;
                        }
                    }
                }
            `}</style>
        </SecondaryPageLayout>
    );
};

export async function getStaticProps() {
    return getPageStaticProps('FAQ');
}

export default Faq;
